import { DisplayMode, PlaybackStateFilter, Sort } from '@annunciate/core';
import { PLAYLIST_ITEMS_GET } from '../queries';
import { request } from '../request';
export const fetchPlaylist = async (client, ctx) => {
    const { collection: { id }, sortOrder, sortField, playbackState, } = ctx;
    const result = await client.fetchQuery({
        queryKey: ['playlist'],
        queryFn: async () => request({
            query: PLAYLIST_ITEMS_GET,
            variables: {
                parentId: id,
                displayMode: DisplayMode.SERIES,
                perPage: 200,
                page: 0,
                sortField: sortField || 'position',
                sortOrder: sortOrder === Sort.DESC ? 'DESC' : 'ASC',
                playbackFilter: playbackState === PlaybackStateFilter.UNPLAYED ? 'UNPLAYED' : 'ALL',
            },
        }),
        gcTime: 0,
        staleTime: 0,
    });
    if (result.errors) {
        throw new Error('An unknown error occurred fetching the playlist. Please contact support.');
    }
    return result.items;
};
//# sourceMappingURL=fetchPlaylist.js.map